function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "jf6va"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17 35C7.611 35 0 27.389 0 18v-1C0 7.611 7.611 0 17 0h1c9.389 0 17 7.611 17 17v1c0 9.389-7.611 17-17 17z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip-aaee7f95-2e0d-4380-a8d5-988c5fbae1bd)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#e5e5e5",
  strokeMiterlimit: 20,
  strokeWidth: 2,
  d: "M17 35C7.611 35 0 27.389 0 18v-1C0 7.611 7.611 0 17 0h1c9.389 0 17 7.611 17 17v1c0 9.389-7.611 17-17 17z",
  clipPath: "url(\"#jf6va\")"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M24.271 16.237h-5.818v-5.818a.83.83 0 0 0-.831-.831h-.554a.83.83 0 0 0-.83.83v5.819h-5.819a.831.831 0 0 0-.831.83v.555c0 .46.372.83.831.83h5.818v5.82c0 .458.372.83.83.83h.555c.46 0 .831-.372.831-.83v-5.82h5.818a.83.83 0 0 0 .832-.83v-.554a.831.831 0 0 0-.832-.831z"
})))))));

var SvgPlusIconOutline = function SvgPlusIconOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusIconOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus-icon-outline.ecdc5f35.svg";
export { ForwardRef as ReactComponent };